import React from "react";
import { Layout } from "../../layouts/Layout";
import { ServicesDetailsFaq2 } from "../../components/ServicesDetails/ServicesDetailsFaq2";
import {
  SD_WORKING_IMG01,
  SD_WORKING_IMG02,
  SERVICES_DETAILS02,
} from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { BrandSeven } from "../../components/Brand/BrandSeven";

const ServicesDetailsPageTwo = () => {
  return (
    <Layout footer = {2} breadcrumb={"Services"} title={"Training & Development"}>
      {/* services-details-area */}
      <ServicesDetailsWrapper>
        <div className="services-details-wrap">
          <div className="services-details-content">
            <h2 className="title">
            Unlocking Potential with Training & Development
            </h2>
            <p>
            In today's fast-paced and competitive business landscape, organizations need to stay ahead of 
            the curve to achieve success. At Trio Management Consultancy, we understand the importance of 
            continuous learning and improvement. That's why we offer a wide range of training programs
             designed to empower businesses to achieve excellence.
            </p>
            <div className="sd-inner-wrap-two">
              <div className="row align-items-center">
                <div className="col-58">
                  <div className="thumb">
                    <img src={SERVICES_DETAILS02} alt="" style={{width:"400px", height:"340px", paddingLeft:"20px"}}/>
                  </div>
                </div>
                <div className="col-42">
                  <div className="services-details-list">
                    <ul className="list-wrap">
                      <li>
                        <div className="icon">
                          <i className="flaticon-business-presentation"></i>
                        </div>
                        <div className="content">
                          <br/>
                          <h6 className="title">Bridge Skill Gaps</h6>
    {/*                      <p>
                          Equip your workforce with the necessary tools to meet emerging challenges and opportunities.
                          </p>
       */}                 </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="flaticon-investment"></i>
                        </div>
                        <div className="content">
                        <br/>
                          <h5 className="title">Boost Employee Performance</h5>
          {/*                <p>
                          Empower employees with practical knowledge to improve efficiency and output.
                          </p>
             */}           </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="flaticon-taxes"></i>
                        </div>
                        <div className="content">
                        <br/>
                          <h5 className="title">Enhance Engagement & Retention</h5>
                {/*          <p>
                            Invest in your teams' growth to build loyalty, reduce turnover, and foster a thriving workplace.
                          </p>
                   */}     </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="industrial-working-wrap">
              <h2 className="title-two">Empower Your Workforce, Drive Your Success</h2>
              <p className="info-one">
              By participating in our comprehensive training programs, organizations can reap a wide range 
              of benefits, including enhanced knowledge and skills, improved productivity and efficiency, 
              increased competitiveness, better decision-making and problem-solving, enhanced collaboration 
              and communication, improved customer satisfaction, increased employee engagement and motivation,
               and better adaptability and resilience. Our training programs are designed to deliver 
               measurable results and tangible business impact, enabling organizations to achieve 
               excellence, drive growth, and stay ahead of the competition
              </p>
              <div className="row">
                <div className="col-md-6">
                  <img src={SD_WORKING_IMG01} alt=""  style={{width: "410px", height:"300px"}}/>
                </div>
                <div className="col-md-6">
                  <img src={SD_WORKING_IMG02} alt="" style={{width: "410px", height:"300px"}} />
                </div>
              </div>
              {/*              <p className="info-two">
              <b>Invest in growth. Invest in success. Partner with Trio Management 
              Consultancy for Training & Development.</b>
              </p> */}
            </div>
            <div className="company-benefit-wrap">
              <h2 className="title-two">Benefits of Our Training Programs:  </h2>
              <p>
              At Trio Management Consultancy, we don’t believe in one-size-fits-all solutions.
               We tailor our training programs to align with your organizational goals and employee needs. 
               Our services include:
              </p>

              {/* faq accordion */}
              <ServicesDetailsFaq2 />
              <br/>
              <div>
              <p>
      At Trio Management Consultancy, we are committed to providing comprehensive training solutions 
      that empower businesses to achieve excellence. Our training programs are designed to meet 
      the unique needs of each organization, and our experienced trainers are dedicated to 
      delivering exceptional training experiences. Contact us today to learn more about our training 
      programs and how we can help your business thrive.
      </p>
      </div>
            </div>
          </div>  
        </div>
      </ServicesDetailsWrapper>

     
      {/* brand-area */}
      <BrandSeven />
    </Layout>
  );
};

export default ServicesDetailsPageTwo;
